import React  from 'react';
import { css } from '@emotion/react';

import { DropdownOption } from '../components/form/DropDown';
import theme from "../../theme";
import DropDown from "../components/form/DropDown";

type Props = {
    onChange: Function,
    options: Array<DropdownOption>,
    selected: DropdownOption
};

const PlanSelectionPlanType: React.FC<Props> = ({
    onChange,
    options,
    selected,
}) => (
    <div css={containerStyle}>
        <DropDown
            extraOptionContainerStyles={extraOptionContainerStyles}
            extraOptionStyles={extraOptionStyles}
            hasBorder={false}
            options={options}
            searchable={false}
            selected={selected}
            setSelected={onChange}
            css={dropdownStyle}
        />
    </div>
);

const dropdownStyle = css`
    height: 100%;
    align-items: center;
`;

const containerStyle =  css`
    width: 125px;
    height: 35px;
    display: flex;
    align-items: center;
    border-top-left-radius: ${theme.borderAndShadow.largerRadius1};
    border-bottom-left-radius: ${theme.borderAndShadow.largerRadius1};
    cursor: pointer;
    font-size: 26px;
    line-height: 17px;
    font-weight: ${theme.fonts.weights.base};
    
    .placeholder-container {
        padding-left: 10px;
    }

    &:hover {
        background: ${theme.colours.grey[300]};
    }
`;

const extraOptionContainerStyles = css`
    width: 125px;
    height: 90px;
    top: 0;
`;

const extraOptionStyles = css`
    height: inherit;
    padding: 5px 5px 5px 11px;

    p {
        font-size: 16px;
    }
`;

export default PlanSelectionPlanType;
